<div>
  Are you having problems validating your address?
  <a
    rv-link
    appearance="inline"
    actionLink
    (click)="addressFactory.confirmAndSetGeneralDelivery(addressObject)"
    >Click here</a
  >.
</div>
